var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8A8E97",
    d: "M16.243 9.878a1 1 0 0 1 1.32-.083l.094.083L19.778 12a5.5 5.5 0 0 1-7.596 7.952L12 19.778l-2.121-2.121a1 1 0 0 1 1.32-1.498l.094.083 2.121 2.122a3.5 3.5 0 0 0 5.091-4.8l-.141-.15-2.121-2.121a1 1 0 0 1 0-1.415M9.17 9.171a1 1 0 0 1 1.32-.083l.095.083 4.242 4.243a1 1 0 0 1-1.32 1.497l-.094-.083-4.243-4.242a1 1 0 0 1 0-1.415m-4.95-4.95a5.5 5.5 0 0 1 7.597-.173l.182.174 2.121 2.12A1 1 0 0 1 12.8 7.84l-.094-.083-2.121-2.121a3.5 3.5 0 0 0-5.091 4.8l.141.15 2.121 2.12a1 1 0 0 1-1.32 1.498l-.094-.083L4.222 12a5.5 5.5 0 0 1 0-7.778Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2Line);
export default __webpack_public_path__ + "static/media/link_2_line.cad8000bd5d1bff9bf901560acf051b6.svg";
export { ForwardRef as ReactComponent };